var $628cb244c12d3d50$exports = {};
const $628cb244c12d3d50$var$displayPoliticsMain = document.querySelector("#politics-main");
const $628cb244c12d3d50$var$displayPoliticsGallery = document.querySelector("#politics-gallery");
const $628cb244c12d3d50$var$displayRightSideBar = document.querySelector("#rightSide-bar");
let $628cb244c12d3d50$var$page = 1;
const $628cb244c12d3d50$var$getGtag = async ()=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
        domain: window.location.hostname
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    const res = await fetch("https://api.voxglobaltech.com/oj/setting/search?page=1&size=1", requestOptions);
    if (!res.ok) throw new Error(`Http error: Status: ${res.status}`);
    const data = await res.json();
    console.log("\uD83D\uDE80 ~ file: dataScript.js:31 ~ getGtag ~ data:", data?.data);
    const resultData = data?.data;
    return resultData;
};
const $628cb244c12d3d50$var$injectScript = async ()=>{
    const payLoad = await $628cb244c12d3d50$var$getGtag();
    console.log("\uD83D\uDE80 ~ file: dataScript.js:39 ~ injectScript ~ payLoad:", payLoad);
    var script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${payLoad[0]?.gTag}`;
    document.head.appendChild(script);
    var gTagscript = document.createElement("script");
    gTagscript.text = `window.dataLayer = window.dataLayer || [];\r\n  function gtag(){dataLayer.push(arguments);}\r\n  gtag(\'js\', new Date());\r\n\r\n  gtag(\'config\', \'${payLoad[0]?.gTag}\'});`;
    document.head.appendChild(gTagscript);
};
const $628cb244c12d3d50$var$getLatestNews = async (pageIndex)=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
        category: "industries"
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    const res = await fetch(`https://api.voxglobaltech.com/oj/paymentplayer_posts/search?page=${pageIndex}&size=20`, requestOptions);
    if (!res.ok) throw new Error(`Http error: Status: ${res.status}`);
    const data = await res.json();
    // console.log("?? ~ file: dataScript.js:26 ~ getLatestNews ~ data:", data)
    return data;
};
const $628cb244c12d3d50$var$latestNews = async ()=>{
    const payLoad = await $628cb244c12d3d50$var$getLatestNews(1);
    // console.log("?? ~ file: dataScript.js:32 ~ latestNews ~ payLoad:", payLoad.data)
    const dataToShow = payLoad.data.slice(0, 4);
    const polityGallery = payLoad.data.slice(5, 20);
    const rightSideBar = payLoad.data;
    let mapPoliticsMainPayload = `<a href=/${dataToShow[0]?.link}.html
                        class="group relative flex h-48 items-end overflow-hidden rounded-lg bg-gray-100 shadow-lg md:h-80">
                        <img src=${dataToShow[0]?.imageLink}
                            loading="lazy" alt="Photo by Minh Pham"
                            class="absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />

                        <div
                            class="pointer-events-none absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50">
                        </div>

                        <span class="relative ml-4 mb-3 inline-block text-sm text-white md:ml-5 md:text-lg">${dataToShow[0]?.title}</span>
                    </a>
                     <a href=/${dataToShow[1]?.link}.html
                        class="group relative flex h-48 items-end overflow-hidden rounded-lg bg-gray-100 shadow-lg md:col-span-2 md:h-80">
                        <img src=${dataToShow[1]?.imageLink}
                            loading="lazy" alt="Photo by Magicle"
                            class="absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />

                        <div
                            class="pointer-events-none absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50">
                        </div>

                        <span class="relative ml-4 mb-3 inline-block text-sm text-white md:ml-5 md:text-lg">${dataToShow[1]?.title}</span>
                    </a><a href=/${dataToShow[2]?.link}.html
                        class="group relative flex h-48 items-end overflow-hidden rounded-lg bg-gray-100 shadow-lg md:col-span-2 md:h-80">
                        <img src=${dataToShow[2]?.imageLink}
                            loading="lazy" alt="Photo by Martin Sanchez"
                            class="absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />

                        <div
                            class="pointer-events-none absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50">
                        </div>

                        <span class="relative ml-4 mb-3 inline-block text-sm text-white md:ml-5 md:text-lg">${dataToShow[2]?.title}</span>
                    </a> <a href=/${dataToShow[3]?.link}.html
                        class="group relative flex h-48 items-end overflow-hidden rounded-lg bg-gray-100 shadow-lg md:h-80">
                        <img src=${dataToShow[3]?.imageLink}
                            loading="lazy" alt="Pic"
                            class="absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />

                        <div
                            class="pointer-events-none absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50">
                        </div>

                        <span class="relative ml-4 mb-3 inline-block text-sm text-white md:ml-5 md:text-lg">${dataToShow[3]?.title || "No Title"}</span>
                    </a>`;
    let mapPolitcsGallery = polityGallery.map((data)=>{
        const { title: title, category: category, slug: slug, link: link, excerpt: excerpt, imageLink: imageLink, date: date, leadActor: leadActor } = data;
        return `<div class="rounded overflow-hidden shadow-lg">

                            <a href=/${link}.html></a>
                            <div class="relative">
                                <a href=/${link}.html>
                                    <img class="w-full"
                                        src=${imageLink}
                                        alt=${slug}>
                                    <div
                                        class="hover:bg-transparent transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25">
                                    </div>
                                </a>



                            </div>
                            <div class="px-6 py-4">

                                 <a href=/${link}.html
                                    class="font-semibold text-lg inline-block hover:text-indigo-600 transition duration-500 ease-in-out">
                                    ${title}</a>
                               
                            </div>
                          
                        </div>`;
    }).join("");
    let rightSideBarData = rightSideBar.map((data)=>{
        const { title: title, category: category, slug: slug, link: link, excerpt: excerpt, imageLink: imageLink, date: date, leadActor: leadActor } = data;
        return `<li class="flex space-y-1 space-x-3">
   <img alt="" class="w-24 h-24 rounded-md" src=${imageLink}>
   <div class="flex flex-col justify-between">
    <div class="flex flex-col space-y-1">
     <a href=/${link}.html>
      <span class="text-gray-700 text-lg font-semibold">
       ${title}
      </span>
     </a>
    </div>
  <!--  <div class="flex space-x-2 items-center">
     <span>
      Date: ${date}
     </span>
    </div>-->
   </div>
  </li>`;
    }).join("");
    $628cb244c12d3d50$var$displayPoliticsMain.innerHTML = mapPoliticsMainPayload;
    $628cb244c12d3d50$var$displayPoliticsGallery.innerHTML = mapPolitcsGallery;
    $628cb244c12d3d50$var$displayRightSideBar.innerHTML = rightSideBarData;
};
const $628cb244c12d3d50$var$includeHTML = ()=>// {
//   const button = document.querySelector('#triggerEl');
//   const menu = document.querySelector('#targetEl');
//   button.addEventListener('click', () => {
//     menu.classList.toggle('hidden');
//   });
//   let langChange = document.querySelector('#lang');
//   if (localStorage.hasCodeRunBefore && !localStorage.telugu) {
//     console.log(
//       '?? ~ file: include.js:37 ~ includeHTML ~ localStorage.hasCodeRunBefore:',
//       localStorage.hasCodeRunBefore
//     );
//     const language = `<li>
//               <a href="?portal=$english#googtrans(te|en)" target="_self"
//                    class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent"></a>
//          </li>`;
//     langChange.innerHTML = language;
//     langChange.addEventListener('click', () => {
//       localStorage.removeItem('hasCodeRunBefore');
//       localStorage.setItem('telugu', true);
//       googleTranslateElementInit('en');
//     });
//   } else if (!localStorage.hasCodeRunBefore && localStorage.telugu) {
//     const language = `<li>
//           <a href="?portal=$telugu#googtrans(en|te)" target="_self"
//                class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
// </a>
//      </li>`;
//     langChange.innerHTML = language;
//     langChange.addEventListener('click', () => {
//       localStorage.removeItem('telugu');
//       localStorage.setItem('hasCodeRunBefore', true);
//       googleTranslateElementInit('te');
//     });
//   } else {
//     const language = `<li>
//           <a href="?portal=$telugu#googtrans(en|te)" target="_self"
//                class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
// </a>
//      </li>`;
//     langChange.innerHTML = language;
//     langChange.addEventListener('click', () => {
//       localStorage.removeItem('telugu');
//       localStorage.setItem('hasCodeRunBefore', true);
//       googleTranslateElementInit('te');
//     });
//   }
// };
// const infinityScroll = async () =>
{
    $(window).scroll(function() {
        if ($(window).scrollTop() == $(document).height() - $(window).height()) {
            $628cb244c12d3d50$var$page += 1;
            $628cb244c12d3d50$var$getLatestNews($628cb244c12d3d50$var$page).then((res)=>{
                // console.log("?? ~ file: dataScript.js:32 ~ latestNews ~ payLoad:", payLoad.data)
                const polityGallery = res.data.slice(0, 20);
                console.log("\uD83D\uDE80 ~ file: videoGallery.js:39 ~ latestVideos ~ videoData:", polityGallery);
                let mapPolitcsGallery = polityGallery.map((data)=>{
                    const { title: title, category: category, slug: slug, link: link, excerpt: excerpt, imageLink: imageLink, date: date, leadActor: leadActor } = data;
                    return `<div class="rounded overflow-hidden shadow-lg">

                            <a href=/${link}.html></a>
                            <div class="relative">
                                <a href=/${link}.html>
                                    <img class="w-full"
                                        src=${imageLink}
                                        alt=${slug}>
                                    <div
                                        class="hover:bg-transparent transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25">
                                    </div>
                                </a>



                            </div>
                            <div class="px-6 py-4">

                                 <a href=/${link}.html
                                    class="font-semibold text-lg inline-block hover:text-indigo-600 transition duration-500 ease-in-out">
                                    ${title}</a>
                               
                            </div>
                          <!--  <div class="px-6 py-4 flex flex-row items-center">
                                <span href="#"
                                    class="py-1 text-sm font-regular text-gray-900 mr-1 flex flex-row items-center">
                                    <svg height="13px" width="13px" version="1.1" id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;"
                                        xml:space="preserve">
                                        <g>
                                            <g>
                                                <path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M277.333,256
                            c0,11.797-9.536,21.333-21.333,21.333h-85.333c-11.797,0-21.333-9.536-21.333-21.333s9.536-21.333,21.333-21.333h64v-128
                            c0-11.797,9.536-21.333,21.333-21.333s21.333,9.536,21.333,21.333V256z"></path>
                                            </g>
                                        </g>
                                    </svg>
                                    <span class="ml-1">Date:${date}</span></span>
                            </div>-->
                        </div>`;
                }).join("");
                $("#politics-gallery").append(mapPolitcsGallery);
            });
        }
    });
};
$628cb244c12d3d50$var$includeHTML();
$628cb244c12d3d50$var$latestNews();
$628cb244c12d3d50$var$injectScript(); // infinityScroll();


//# sourceMappingURL=index.e410a7a6.js.map
